<div class="relative flex items-center justify-between border border-white-900 rounded pl-4 bg-white"
  [ngClass]="{'disabled-datepicker': control.disabled}">
  <p class="absolute z-10 text-white-300 text-xs -top-5 left-0" *ngIf="label">{{label}}</p>
  <input [id]="componentId + '-datepicker'" [attr.data-cy]="componentId + '-datepicker'" matInput [min]="min"
    [max]="max" [matDatepicker]="picker2" type="text" [formControl]="control" [placeholder]="placeholder"
    (dateChange)="dateChange($event)" class="w-3/4">
  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
  <mat-datepicker #picker2></mat-datepicker>
</div>
